import React, {Component} from "react";

import Ecg from '../Ecg';

import {
  Row,
  Col,
  Button,
  ButtonGroup,
  Label,
  Input,
  Table
} from "reactstrap";


class EcgPanel extends Component {

    constructor(props) {
        super(props);

        this.toggleDerivation = this.props.onDerivationClick.bind(this);
    }

    render(){

      if(this.props.derivations == null) return (null);

      return (
        <div>
            <Row className="row-no-padding row-bordered ecg-panel-row row-selectable">
                <Col xs="12" sm="3" onClick={() => { this.toggleDerivation(1); }}>
                    <Ecg ecgData={this.props.derivations[0]} id="ecg-1" drawGrid={true} drawMarks={false}
                        totalTime="10" displayTime="2.5" startFrom={this.props.startFromInit ? "0" : "7.5"} ECGLineColor="#005500" traceName="I"
                        ecgSampleRate={this.props.ecgSampleRate} ecgResolution={this.props.ecgResolution} drawInnerGrid={true}
                        />
                </Col>

                <Col xs="12" sm="3" onClick={() => { this.toggleDerivation(4); }}>
                    <Ecg ecgData={this.props.derivations[3]} id="ecg-2" drawGrid={true} drawMarks={false}
                        totalTime="10" displayTime="2.5" startFrom={this.props.startFromInit ? "0" : "7.5"} ECGLineColor="#005500" traceName="aVR"
                        ecgSampleRate={this.props.ecgSampleRate} ecgResolution={this.props.ecgResolution} drawInnerGrid={true}
                        />
                </Col>

                <Col xs="12" sm="3" onClick={() => { this.toggleDerivation(7); }}>
                    <Ecg ecgData={this.props.derivations[6]} id="ecg-3" drawGrid={true} drawMarks={false}
                        totalTime="10" displayTime="2.5" startFrom={this.props.startFromInit ? "0" : "7.5"} ECGLineColor="#005500" traceName="V1"
                        ecgSampleRate={this.props.ecgSampleRate} ecgResolution={this.props.ecgResolution} drawInnerGrid={true}
                        />
                </Col>

                <Col xs="12" sm="3" onClick={() => { this.toggleDerivation(10); }}>
                    <Ecg ecgData={this.props.derivations[9]} id="ecg-4" drawGrid={true} drawMarks={false}
                        totalTime="10" displayTime="2.5" startFrom={this.props.startFromInit ? "0" : "7.5"} ECGLineColor="#005500" traceName="V4"
                        ecgSampleRate={this.props.ecgSampleRate} ecgResolution={this.props.ecgResolution} drawInnerGrid={true}
                        />
                </Col>
            </Row>

            <Row className="row-no-padding row-bordered ecg-panel-row row-selectable">
                <Col xs="12" sm="3" onClick={() => { this.toggleDerivation(2); }}>
                    <Ecg ecgData={this.props.derivations[1]} id="ecg-5" drawGrid={true} drawMarks={false}
                        totalTime="10" displayTime="2.5" startFrom={this.props.startFromInit ? "0" : "7.5"} ECGLineColor="#005500" traceName="II"
                        ecgSampleRate={this.props.ecgSampleRate} ecgResolution={this.props.ecgResolution}  drawInnerGrid={true}/>
                </Col>

                <Col xs="12" sm="3" onClick={() => { this.toggleDerivation(5); }}>
                    <Ecg ecgData={this.props.derivations[4]} id="ecg-6" drawGrid={true} drawMarks={false}
                        totalTime="10" displayTime="2.5" startFrom={this.props.startFromInit ? "0" : "7.5"} ECGLineColor="#005500" traceName="aVL"
                        ecgSampleRate={this.props.ecgSampleRate} ecgResolution={this.props.ecgResolution}  drawInnerGrid={true}/>
                </Col>

                <Col xs="12" sm="3" onClick={() => { this.toggleDerivation(8); }}>
                    <Ecg ecgData={this.props.derivations[7]} id="ecg-7" drawGrid={true} drawMarks={false}
                        totalTime="10" displayTime="2.5" startFrom={this.props.startFromInit ? "0" : "7.5"} ECGLineColor="#005500" traceName="V2"
                        ecgSampleRate={this.props.ecgSampleRate} ecgResolution={this.props.ecgResolution}  drawInnerGrid={true}/>
                </Col>

                <Col xs="12" sm="3" onClick={() => { this.toggleDerivation(11); }}>
                    <Ecg ecgData={this.props.derivations[10]} id="ecg-8" drawGrid={true} drawMarks={false}
                        totalTime="10" displayTime="2.5" startFrom={this.props.startFromInit ? "0" : "7.5"} ECGLineColor="#005500" traceName="V5"
                        ecgSampleRate={this.props.ecgSampleRate} ecgResolution={this.props.ecgResolution}  drawInnerGrid={true}/>
                </Col>
            </Row>

            <Row className="row-no-padding row-bordered ecg-panel-row row-selectable">
                <Col xs="12" sm="3" onClick={() => { this.toggleDerivation(3); }}>
                    <Ecg ecgData={this.props.derivations[2]} id="ecg-9" drawGrid={true} drawMarks={false}
                        totalTime="10" displayTime="2.5" startFrom={this.props.startFromInit ? "0" : "7.5"} ECGLineColor="#005500" traceName="III"
                        ecgSampleRate={this.props.ecgSampleRate} ecgResolution={this.props.ecgResolution}  drawInnerGrid={true}/>
                </Col>

                <Col xs="12" sm="3" onClick={() => { this.toggleDerivation(6); }}>
                    <Ecg ecgData={this.props.derivations[5]} id="ecg-10" drawGrid={true} drawMarks={false}
                        totalTime="10" displayTime="2.5" startFrom={this.props.startFromInit ? "0" : "7.5"} ECGLineColor="#005500" traceName="aVF"
                        ecgSampleRate={this.props.ecgSampleRate} ecgResolution={this.props.ecgResolution}  drawInnerGrid={true}/>
                </Col>

                <Col xs="12" sm="3" onClick={() => { this.toggleDerivation(9); }}>
                    <Ecg ecgData={this.props.derivations[8]} id="ecg-11" drawGrid={true} drawMarks={false}
                        totalTime="10" displayTime="2.5" startFrom={this.props.startFromInit ? "0" : "7.5"} ECGLineColor="#005500" traceName="V3"
                        ecgSampleRate={this.props.ecgSampleRate} ecgResolution={this.props.ecgResolution}  drawInnerGrid={true}/>
                </Col>

                <Col xs="12" sm="3" onClick={() => { this.toggleDerivation(12); }}>
                    <Ecg ecgData={this.props.derivations[11]} id="ecg-12" drawGrid={true} drawMarks={false}
                        totalTime="10" displayTime="2.5" startFrom={this.props.startFromInit ? "0" : "7.5"} ECGLineColor="#005500" traceName="V6"
                        ecgSampleRate={this.props.ecgSampleRate} ecgResolution={this.props.ecgResolution}  drawInnerGrid={true}/>
                </Col>

            </Row>

            <Row className="row-no-padding row-bordered ecg-panel-row ">
                <Col xs="12" sm="12">
                <Ecg ecgData={this.props.derivations[1]} id="ecg-DII" drawGrid={true} drawMarks={false}
                  totalTime="10" displayTime="10" ECGLineColor="#005500" traceName="II"
                  ecgSampleRate={this.props.ecgSampleRate} ecgResolution={this.props.ecgResolution}  drawInnerGrid={true}/>

                </Col>
            </Row>
        </div>
      );
    }
}
export default EcgPanel;



// WEBPACK FOOTER //
// ./src/views/EcgPanel/EcgPanel.js